import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

const relatedPosts = document.querySelector(".related-posts");

document.addEventListener("DOMContentLoaded", () => {
  const container = relatedPosts.querySelector(".swiper");

  if (!container) {
    return;
  }

  new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 750,
    navigation: {
      nextEl: relatedPosts.querySelector(".slider-button-next"),
      prevEl: relatedPosts.querySelector(".slider-button-prev"),
    },
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 24,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 36,
      },
      1024: {
        slidesPerView: 2.2,
        spaceBetween: 40,
      },
    },
  });
});
